import type { UpdateCategory } from '@mynt/backoffice-api-spec/spendcontrols'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SPEND_CATEGORIES } from 'api/react-query/keys'
import { updateCategory } from 'SpendControl/endpoints'

export type UpdateCategoryParams = { id: string } & UpdateCategory

export const useUpdateCategory = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({ id, ...body }: UpdateCategoryParams) => updateCategory(id, body),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [SPEND_CATEGORIES] })
    },
  })
}
